let     w_resizeTimer,
        //w_scrollTimer,
        w_lang;

const   w_base = '/',
        w_myScreen = {},
        w_myBrowser = {
            engine: '',
            version: 0,
            os: ''
        };

window.addEventListener('DOMContentLoaded',function()
{
    // get language from HTML
    w_lang = document.documentElement.lang;

    // get os, browser engine and version
    get_browser();
    if(w_myBrowser.engine === 'blink')
    {
        document.body.classList.add('chrome');
    }

    // get screen size
    get_screenSize();

    if(w_myBrowser.mobile === true)
    {
        document.body.classList.remove('w__hover');
    }

    if(document.getElementById('w--googlemap'))
    {
        load_googlemapApi(document.getElementById('w--googlemap'));
    }

    if(document.getElementById('w--images'))
    {
        new SlideShow(document.getElementById('w--images'));
    }

    document.getElementById('w--mobile-button').addEventListener('click',() =>
    {
        document.getElementById('w--mobile-button').classList.toggle('active');
        document.getElementById('w--nav').classList.toggle('active');
    });
});

class SlideShow
{
    constructor(container)
    {
        this.container = container;
        const myImages = this.container.querySelectorAll('.w__images--img,.w__images--load');
        this.imageCount = myImages.length;
        this.activeImageCount = 0;
        this.lastActiveImgNo = 0;
        this.images = [];
        this.zIndex = 1;
        for(let i=0; i<this.imageCount; i++)
        {
            this.images[i] = myImages[i];
            const elStyles = getComputedStyle(this.images[i]);
            if(this.images[i].classList.contains('w__images--img') && elStyles.opacity === '1')
            {
                this.images[i].style.opacity = '1';
                this.images[i].style.zIndex = '1';
                this.activeImageCount++;
                this.lastActiveImgNo = i;
            }
            else
            {
                this.images[i].style.opacity = '0';
            }
        }

        if(this.imageCount >= this.activeImageCount * 2)
        {
            setTimeout(() => {
                this.nextImages();
            },5000);
        }
    }

    nextImages()
    {
        const nextImageNumbers = [];
        for(let i=0; i<this.activeImageCount; i++)
        {
            nextImageNumbers[i] = this.lastActiveImgNo + 1 + i;
            if(nextImageNumbers[i] >= this.imageCount)
            {
                nextImageNumbers[i] = nextImageNumbers[i] - this.imageCount;
            }
        }

        this.prepareImages(nextImageNumbers).then(() => {
            this.showImages(nextImageNumbers);
        });
    }

    showImages(nextImageNumbers)
    {
        this.zIndex++;
        for(let i=0; i<this.activeImageCount; i++)
        {
            let oldNo = nextImageNumbers[i] - this.activeImageCount;
            if(oldNo < 0)
            {
                oldNo += this.imageCount;
            }
            this.images[oldNo].style.opacity = '0';
            this.images[nextImageNumbers[i]].style.zIndex = this.zIndex.toString();
            this.images[nextImageNumbers[i]].style.opacity = '1';
            this.images[nextImageNumbers[i]].className = "w__images--img w__images--pos-" + (i + 1).toString()
            this.lastActiveImgNo = nextImageNumbers[i];
        }
        setTimeout(() => {
            this.nextImages();
        },5000);
    }

    prepareImages(nextImageNumbers)
    {
        return new Promise(resolve =>
        {
            let loaded = 0;
            for(let i=0; i<nextImageNumbers.length; i++)
            {
                const no = nextImageNumbers[i];
                if(this.images[no].classList.contains('w__images--img'))
                {
                    loaded++;
                    if(loaded === this.activeImageCount)
                    {
                        resolve(true);
                    }
                }
                else
                {
                    const newImage = new Image();
                    newImage.src = this.images[no].href;
                    newImage.style.opacity = '0';
                    newImage.classList.add('w__images--img');
                    newImage.addEventListener('load',() =>
                    {
                        this.images[no].insertAdjacentElement('afterend', newImage);
                        newImage.offsetHeight;
                        this.images[no].remove();
                        this.images[no] = newImage;
                        loaded++;
                        if(loaded === this.activeImageCount)
                        {
                            resolve(true);
                        }
                    });
                }
            }
        });
    }
}

const load_googlemapApi = function(parentEl)
{
    const myLibrary = document.createElement('script');
    myLibrary.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDMCAoVn7J_cJwS2EoNlIO813Ni_gdBPgA';
    myLibrary.onload = function()
    {
        build_googlemap(parentEl);
    };
    document.head.appendChild(myLibrary);
}

const build_googlemap = function(parentEl)
{
    const myMapCanvas = document.createElement('div');
    myMapCanvas.classList.add('w__googlemap--inner');
    parentEl.appendChild(myMapCanvas);
    const latLng = {lat: 50.1267279, lng: 8.7047684};

    const myOptions = {
        zoom: 16,
        center: latLng,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        zoomControl: true,
        draggable: true,
        styles: [{
            featureType: 'all', stylers: [
            {
                saturation: -100}, {
                    gamma: 0.80}, {
                        hue: '#EF767A'}]},
            {
                featureType: 'water', stylers: [
                {
                    color: '#2F52A0'}]},
            {
                featureType: 'poi.park', stylers: [
                {
                    color: '#95E06C'}]},
            {
                featureType: 'poi', elementType: 'labels', stylers: [
                {
                    visibility: 'off'}]}]
    };
    const map = new google.maps.Map(myMapCanvas, myOptions);
    const marker = new google.maps.Marker(
        {
            position: latLng,
            map: map,
            icon: {url: w_base + 'pix/marker.svg'}
        });
    map.setOptions({disableDefaultUI: true});
    marker.setMap(map);
};

/**
 * analyze browser engine, os and mobile
 */
const get_browser = function()
{
    w_myBrowser.mobile = false;

    if(navigator.vendor && navigator.vendor.match(/google/i))
    {
        w_myBrowser.engine = 'blink';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*chrome\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.vendor && navigator.vendor.match(/apple/i))
    {
        w_myBrowser.engine = 'webkit';
        w_myBrowser.version = parseFloat(navigator.userAgent.replace(/.*version\/([1-9][0-9]*(\.[1-9])?).*/i,'$1'));
    }
    else if(navigator.userAgent.match(/firefox\//i))
    {
        w_myBrowser.engine = 'gecko';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*firefox\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/edge\//i))
    {
        w_myBrowser.engine = 'edgehtml';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*edge\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/trident\//i))
    {
        w_myBrowser.engine = 'trident';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*trident\/([1-9][0-9]*)\..*/i,'$1')) + 4;
    }

    switch(navigator.platform.toLowerCase())
    {
        case 'win32':
            w_myBrowser.os = 'windows';
            break;

        case 'macintel':
            // detect iOS on iPadOS/Safari 13
            if(navigator.maxTouchPoints > 1)
            {
                w_myBrowser.os = 'ios';
                w_myBrowser.mobile = true;
            }
            else
            {
                w_myBrowser.os = 'osx';
            }
            break;

        case 'ipad':
        case 'iphone':
            w_myBrowser.os = 'ios';
            w_myBrowser.mobile = true;
            break;

        default:
            if(navigator.userAgent.match(/android/i))
            {
                w_myBrowser.os = 'android';
                w_myBrowser.mobile = true;
            }
            else if(navigator.platform.match(/linux/i))
            {
                w_myBrowser.os = 'linux';
            }
    }
};

/**
 * returns element dimensions and positions
 *
 * @param el
 * @returns {ClientRect | DOMRect}
 */
const get_elementInfo = function(el)
{
    return el.getBoundingClientRect(document.body);
};

/**
 * Measures and stores various screen parameters
 */
const get_screenSize = function()
{
    // pixel density
    w_myScreen.highDpi = window.devicePixelRatio ? window.devicePixelRatio : 1;
    if(w_myScreen.highDpi > 2)
    {
        w_myScreen.highDpi = 2;
    }

    // screen size
    if(w_myBrowser.mobile === true)
    {
        w_myScreen.x = window.innerWidth;
        w_myScreen.y = window.innerHeight;
    }
    else
    {
        w_myScreen.x = document.body.clientWidth;
        w_myScreen.y = window.innerHeight;
    }

    w_myScreen.lastLayout = w_myScreen.layout;

    switch(parseInt(window.getComputedStyle(document.body).getPropertyValue('border-bottom-color').substr(4,1)))
    {
        case 1:
            w_myScreen.layout = 'tablet';
            break;
        case 2:
            w_myScreen.layout = 'smartphone';
            break;

        default:
            w_myScreen.layout = 'desktop';
    }

    if(w_myScreen.lastLayout &&
       w_myScreen.layout !== w_myScreen.lastLayout)
    {
        document.location.reload(true);
    }
};

/**
 * returns a randum number between 0 and max
 *
 * @param max
 * @returns {number}
 */
const get_randomInt = function(max)
{
    return Math.floor(Math.random() * Math.floor(max));
};

// VARIOUS POLYFILLS
/**
 * polyfill for element.remove()
 */
if(!Element.prototype.remove)
{
    Element.prototype.remove = function()
    {
        if(this && this.parentNode)
        {
            this.parentNode.removeChild(this);
        }
    };
}

/**
 * polyfill element.matches()
 */
if(!Element.prototype.matches)
{

    // noinspection JSUnresolvedVariable
    Element.prototype.matches = Element.prototype.matchesSelector ||
                               Element.prototype.mozMatchesSelector ||
                               Element.prototype.msMatchesSelector ||
                               Element.prototype.oMatchesSelector ||
                               Element.prototype.webkitMatchesSelector;
}

/**
 * polyfill for element.closest()
 */
if(!Element.prototype.closest)
{
    Element.prototype.closest = function(selector)
    {
        let el = this,
            found = 0,
            returnEl = false;

        while(found === 0)
        {
            if(el.parentNode && el.parentNode !== document.body)
            {
                el = el.parentNode;
                if(el.nodeType === 1 &&
                   el.matches(selector))
                {
                    found = 1;
                    returnEl = el;
                }
            }
            else
            {
                found = -1;
            }
        }
        return returnEl;
    };
}

/**
 * polyfill for element.dataset
 */
if (!document.documentElement.dataset &&
    (!Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'dataset') ||
        !Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'dataset').get))
{
    const descriptor = {};
    descriptor.enumerable = true;
    descriptor.get = function get()
    {
        const element = this,
            map = {},
            attributes = this.attributes;

        function toUpperCase(n0)
        {
            return n0.charAt(1).toUpperCase();
        }
        function getter()
        {
            return this.value;
        }
        function setter(name, value)
        {
            if(typeof value !== 'undefined')
            {
                this.setAttribute(name, value);
            }
            else
            {
                this.removeAttribute(name);
            }
        }

        for(let i=0; i<attributes.length; i += 1)
        {
            const attribute = attributes[i];

            // This test really should allow any XML Name without
            // colons (and non-uppercase for XHTML)

            if(attribute && attribute.name && (/^data-\w[\w-]*$/).test(attribute.name))
            {
                const name = attribute.name,
                    value = attribute.value;

                // Change to CamelCase
                const propName = name.substr(5).replace(/-./g, toUpperCase);

                Object.defineProperty(map, propName,
                    {
                        enumerable: descriptor.enumerable,
                        get: getter.bind({ value: value || '' }),
                        set: setter.bind(element, name)
                    });
            }
        }
        return map;
    };
    Object.defineProperty(HTMLElement.prototype, 'dataset', descriptor);
}

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(w_resizeTimer);
    w_resizeTimer = requestAnimationFrame(get_screenSize);
});

/*
// window scroll detection
window.addEventListener('scroll',() =>
{
    cancelAnimationFrame(w_scrollTimer);
    w_scrollTimer = requestAnimationFrame(do_onScroll);
});
 */